var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.$t.__(_vm.getExtensionOption(_vm.option).label),
            placement: "top",
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled
          }
        },
        [
          _c("CompassIconButton", {
            ref: "customTagsRichTextTrigger",
            attrs: {
              icon: _vm.getExtensionOption(_vm.option).icon,
              size: "small",
              disabled: _vm.disabled
            },
            on: { click: _vm.showMenu }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            title: _vm.$t.__(_vm.getExtensionOption(_vm.option).label),
            isVisible: _vm.showMenuCustomTags,
            "custom-class": "custom-popover-customtags",
            "no-close-on-click-outside": ".customtags-select",
            triggerRef: "customTagsRichTextTrigger"
          },
          on: { close: _vm.hideMenu }
        },
        [
          _c(
            "div",
            { staticClass: "flex-row" },
            [
              !_vm.loading
                ? _c(
                    "CompassSelect",
                    {
                      attrs: {
                        placeholder: _vm.$t.__(
                          "richtext.customoptions.CustomTagsRichText.search_tag"
                        ),
                        "menu-class": "customtags-select"
                      },
                      model: {
                        value: _vm.selectedTag,
                        callback: function($$v) {
                          _vm.selectedTag = $$v
                        },
                        expression: "selectedTag"
                      }
                    },
                    _vm._l(_vm.tags, function(group) {
                      return _c(
                        "CompassOptionGroup",
                        {
                          key: group.label,
                          attrs: { label: _vm.$t.__(group.label) }
                        },
                        _vm._l(group.options, function(option) {
                          return _c("CompassDropdownSelectOption", {
                            key: option.value,
                            attrs: {
                              label: _vm.$t.__(option.label),
                              value: option.value
                            }
                          })
                        }),
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-2",
                attrs: {
                  label: _vm.$t.__("common.actions.add"),
                  type: "primary",
                  disabled: !_vm.selectedTag
                },
                on: { click: _vm.addTag }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }